<template>
	<el-dialog :visible="show" append-to-body width="740px" title="添加场景" :close-on-click-modal="false" @close="closeDialog">
		<el-form label-width="60px">
			<el-form-item label="场景" prop="materialData" required>
				<vr-upload v-model="materialData" :loading.sync="doSubmitLoading" />
				<div class="v-form-tips">请上传2:1的全景图片，例如：宽6000px，高3000px，拖拽可以进行排序</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="closeDialog">关闭</el-button>
			<el-button type="primary" size="small" :loading="doSubmitLoading" @click="doSubmit">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import {mapActions,mapState} from 'vuex';
	import vrUpload from '@/pages-saas/works/components/vr-upload'

	export default {

		components: {vrUpload},

		props: {
			show: Boolean,
		},

		data() {
			return {
				doSubmitLoading: false,
				worksId: this.$route.query.id,
				worksType: this.$route.query.type,
				materialData: [],
			}
		},

		computed: {
			...mapState('tour', ['activeGroupId','sceneDetail']),
		},

		methods: {

			...mapActions("tour", {
				actionGetWorksDetail: "getWorksDetail",
			}),

			closeDialog() {
				this.$emit('update:show', false)
			},

			async doSubmit() {
				if (this.materialData.length == 0) {
					this.$message.error('请先上传全景图片')
					return
				}
				this.doSubmitLoading = true;
				try {
					await this.api.material.addSingleMaterial({worksId: this.worksId, materialData: this.materialData,groupId:this.sceneDetail.groupId});
					await this.actionGetWorksDetail({worksId: this.$route.query.id});
					this.$message.success(`添加成功`);
					this.closeDialog();
				} catch (e) {
					console.error(e);
				}
				this.doSubmitLoading = false;
			},


		}
	}
</script>

